import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { ContactMethodFormatter } from '@pbx/services/formatter/ContactMethod';
import { isSIP } from '@pbx/helpers/contact-methods';
import { DATA } from '@/plugins/vuex-async-pagginate';

class SipAccountServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getList(params = {}) {
    return this.pure_http.get('/pbx/client/sip-accounts', { params: params }).then(res => {
      const data = ContactMethodFormatter.formatItems(res[DATA]);
      return {
        ...res,
        [DATA]: data
      };
    });
  }

  getSelect(params = {}) {
    return this.pure_http
      .get(`/pbx/client/select/sip-accounts`, { params: params })
      .then(items => ContactMethodFormatter.formatItems(items));
  }

  getSelectFree(params = {}) {
    return this.pure_http
      .get(`/pbx/client/select/sip-accounts/free`, { params: params })
      .then(items => ContactMethodFormatter.formatItems(items));
  }

  getFreeSipsOnlySelect(params = {}) {
    return this.getSelectFree(params).then(items => items.filter(sip => isSIP(sip)));
  }

  getFreeInternalsOnlySelect(params = {}) {
    return this.getSelectFree(params).then(items => items.filter(sip => !isSIP(sip)));
  }

  editItem(id, params = {}) {
    return this.http.put(`/${id}`, params);
  }
}

export const SipAccountService = new SipAccountServiceClass({
  api_version: 2,
  resource: 'pbx/sip-accounts'
});
